export enum UserPlanTypeEnum {
  promotion = 'promotion',
  freemium = 'freemium',
  'automaticUpgrade' = 'automatic-upgrade',
}

// these are user plans with type 'automatic-upgrade' (meaning user can upgrade by himself) + default user plan (freemium)
export enum AvailablePlansEnum {
  freemium = 40,
  startup = 42,
  startupNew = 53,
  webinar = 43,
  enterprise = 44,
}
